export * from "./getPartnerHeadings";
